(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name stationFlightHandling.factory:StationFlightHandlingFactory
     *
     * @description
     *
     */
    angular
    	.module('stationFlightHandling')
        .factory('StationFlightHandlingFactory', StationFlightHandlingFactory);

    function StationFlightHandlingFactory() {



    }
})();
